import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import RoleService from '../../../services/RoleService/RoleService';
import Action from './Action';

/**
 * @Description This function lets you return Actions component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
export default function Actions({module, roleID}) {
    const {t} = useTranslation();
    const [libraries, setLibraries] = useState([]);
    useEffect(() => {
        fetchData().then(r => r);
    }, []);
    const fetchData = async () => {
        let response = await RoleService.getRoleLibraries(module.id, roleID);
        if (response?.status) {
            setLibraries(response.data.libraries);
        }
        module.libraries = response.data.libraries;
    }
    return (
        <Table size="small">
            <TableBody>
                {libraries?.map((item) => (
                    <TableRow key={item.library_name}>
                        <TableCell style={{width: 180}}><span
                            className="role-name sec">{t('CONTENT.LIBRARY.' + item.library_name + '.NAME')}</span></TableCell>
                        <TableCell style={{width: 130}}/>
                        <Action library={item}/>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
